/**
 * GtChartColors.ts
 * ─────────────────────────────────────────────────────────────────────────────
 * Self-contained color tokens and default palette for GtChart.
 * Intentionally has zero external imports so GtChart can be extracted as a
 * standalone package without modification.
 *
 * Tokens are drawn from Tailwind's semantic color scale (Blue, Green, Red,
 * Amber, Orange, Violet, Teal) at the 500–600 range for equal visual weight
 * on bar / area / line charts.
 *
 * Usage:
 *   import { CHART_PALETTE } from './GtChartColors';
 */

// ── Color tokens ──────────────────────────────────────────────────────────────

const BLUE = '#60A5FA'; // Tailwind Blue 400    — informational / in-progress
const GREEN = '#40BF77'; // Custom success green  — success / resolved
const AMBER = '#FCD34D'; // Tailwind Amber 300   — warning / attention
const RED = '#F87171'; // Tailwind Red 400     — failure (primary)
const RED_2 = '#EF4444'; // Tailwind Red 500     — failure (secondary)
const ORANGE = '#FB923C'; // Tailwind Orange 400  — patch / warm failure
const VIOLET = '#C084FC'; // Tailwind Violet 400  — tertiary accent
const TEAL = '#2DD4BF'; // Tailwind Teal 400    — calm accent

// ── Default palette ───────────────────────────────────────────────────────────

/**
 * General-purpose 8-color default palette for GtChart.
 * Order: positive → in-progress → warning → danger × 3 → accent × 2.
 * Colorblind-safe — no red/green adjacency.
 */
export const CHART_PALETTE: string[] = [
    GREEN,  // 1 — success / resolved
    BLUE,   // 2 — informational / in-progress
    AMBER,  // 3 — warning / attention
    RED,    // 4 — failure (primary)
    RED_2,  // 5 — failure (secondary)
    ORANGE, // 6 — failure (patch / warm)
    VIOLET, // 7 — tertiary accent
    TEAL,   // 8 — calm accent
];
